import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import ProChioseTabMember from "./pro-chiose-tab-member.vue";
import ProChioseTabStructure from "./pro-chiose-tab-structure.vue";
import ProChioseTabPosition from "./pro-chiose-tab-position.vue";
import ProChioseTabApps from "./pro-chiose-tab-apps.vue";
import ProChioseRight from "./pro-chiose-right";
import ProChioseTabs from "@/components/pro-common/pro-chiose-modal/pro-chiose-tabs.vue";
import ProChioseTabDepartmemt from "@/components/pro-common/pro-chiose-modal/pro-chiose-tab-departmemt.vue";
import { treeWithMember, departmentTree, assignableApps, tagListNoPage } from "@/service/structure.js";
export default {
  name: "pro-chiose-address-book",
  components: {
    ProChioseTabMember,
    ProChioseTabs,
    ProChioseTabDepartmemt,
    ProChioseTabStructure,
    ProChioseTabPosition,
    ProChioseTabApps,
    ProChioseRight
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    title: {
      type: String,
      default() {
        return "";
      }
    },
    tabs: {
      type: Array,
      default() {
        return ["departmemt"];
      }
    }
  },
  data() {
    return {
      loading: false,
      tabValue: "",
      treeData: [],
      positionList: [],
      applist: [],
      checkedList: []
    };
  },
  computed: {
    _departmemtTabShow() {
      return this.tabs.includes("departmemt");
    },
    _memberTabShow() {
      return this.tabs.includes("member");
    },
    _structureTabShow() {
      return this.tabs.includes("structure");
    },
    _positionTabShow() {
      return this.tabs.includes("position");
    },
    _appsTabShow() {
      return this.tabs.includes("apps");
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.open();
        } else {
          this.treeData = [];
          this.positionList = [];
          this.tabValue = this.tabs[0];
          this.checkedList = [];
          this.applist = [];
        }
      }
    },
    checkedList: {
      handler(val) {
        this.$emit("input", val);
      },
      immediate: true
    }
  },
  mounted() {
    this.tabValue = this.tabs[0];
  },
  methods: {
    open() {
      if (this._departmemtTabShow) {
        this.getTreeDepartmemtData();
      }
      if (this._memberTabShow || this._structureTabShow) {
        this.getDataTree();
      }
      if (this._positionTabShow) {
        this.getPositionList();
      }
      if (this._appsTabShow) {
        this.getAppList();
      }
    },
    async getTreeDepartmemtData() {
      this.loading = true;
      let {
        data
      } = await departmentTree();
      if (data && data.result === 0) {
        let treeData = [data.retVal];
        this.setInitDG(treeData);
        this.DGId(treeData);
        this.treeData = treeData;
      }
      this.loading = false;
    },
    async getDataTree() {
      this.loading = true;
      let {
        data
      } = await treeWithMember();
      if (data && data.result === 0) {
        let treeData = [data.retVal];
        this.setInitDG(treeData);
        this.DGId(treeData);
        this.treeData = treeData;
      }
      this.loading = false;
    },
    /*
     * 回显
     */
    setInitDG(treeData) {
      let setNodeChecked = (arr = []) => {
        arr.forEach(v => {
          let ids = ["orgId", "userId"];
          ids.forEach(i => {
            if (v[i]) {
              let find = this.value.find(check => {
                if (check[i] && v[i]) {
                  return check[i] === v[i];
                }
              });
              if (find) {
                v.isCheck = true;
                if (v.userName) {
                  v.name = v.userName;
                }
                this.checkedList.push(v);
              } else {
                v.isCheck = false;
              }
            }
          });
        });
      };
      treeData.forEach(v => {
        if (v.organizationUsers) {
          setNodeChecked(v.organizationUsers);
        }
        setNodeChecked([v]);
        if (v.children && v.children.length > 0) {
          this.setInitDG(v.children);
        }
      });
    },
    /*
     * 设置id，为了已选的删除使用
     */
    DGId(treeData) {
      treeData.forEach(v => {
        if (v.organizationUsers) {
          v.organizationUsers.forEach(user => {
            user.id = user.userId;
          });
        }
        v.id = v.orgId;
        if (v.children && v.children.length > 0) {
          this.DGId(v.children);
        }
      });
    },
    async getPositionList() {
      this.loading = true;
      const {
        data
      } = await tagListNoPage();
      this.loading = false;
      if (data && data.result === 0) {
        data.retVal.forEach(v => {
          v.name = v.tagName;
          // 回显
          let find = this.value.find(tag => tag.tagId === v.tagId);
          if (find) {
            v.isCheck = true;
            this.checkedList.push(v);
          }
        });
        this.positionList = data.retVal;
      }
    },
    async getAppList() {
      this.loading = true;
      const {
        data
      } = await assignableApps();
      this.loading = false;
      if (data && data.result === 0) {
        data.retVal.forEach(v => {
          v.apps.forEach(app => {
            let {
              appId = "",
              id = ""
            } = app;
            app.id = appId || id;
            app.appId = appId || id;
            app.isCheck = false;
            // 回显
            let find = this.value.find(m => m.id === app.id || m.appId === app.id);
            if (find) {
              app.isCheck = true;
              this.checkedList.push(app);
            }
          });
        });
        this.applist = data.retVal;
      }
    },
    /*
     * 点击清空
     */
    onClearAll() {
      if (this.tabValue === "member") {
        this.$refs["ProChioseTabMember"].clearAll();
      } else if (this.tabValue === "structure") {
        this.$refs["ProChioseTabStructure"].clearAll();
      }
    },
    /*
     * 以选中删除一个
     */
    onClearOne(item) {
      if (this.tabValue === "member") {
        this.$refs["ProChioseTabMember"].clearOne(item);
      } else if (this.tabValue === "structure") {
        this.$refs["ProChioseTabStructure"].clearOne(item);
      }
    }
  }
};